import { useState, useCallback } from 'react';
import { translations } from '../i18n/translations';

export const useLanguage = () => {
  const [currentLanguage, setCurrentLanguage] = useState<'en' | 'zh'>('en');

  const toggleLanguage = useCallback(() => {
    setCurrentLanguage(prev => prev === 'en' ? 'zh' : 'en');
  }, []);

  const t = translations[currentLanguage];

  return {
    currentLanguage,
    toggleLanguage,
    t
  };
}; 